import React from 'react';

import { TextField, InputAdornment } from '@mui/material';

import { Search } from 'lucide-react';

import { COLORS } from '../../../Constant/COLORS';

function SearchField(props) {
  return (
    <TextField
      placeholder='Search...'
      type='search'
      InputProps={{
        sx: { borderRadius: '99px', py: 0.5 },
        startAdornment: (
          <InputAdornment position='start'>
            <Search size={18} color={COLORS.inkSoft} strokeWidth={1.8} />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}

export default React.memo(SearchField);
